import { DataTableFilterState } from "../components/Tables/DataTable/DataTable"
import { ColumnConfig } from "../types"
import { toLowerCaseCustom } from "../utils"
import { FilterService } from "./filterService"

const filterService = new FilterService()

export class TableService {
  convertPfColumnConfigToGridColDef = (columnConfig: ColumnConfig[]) => {
    return columnConfig.map((column: ColumnConfig) => {
      return {
        field: column.key,
        headerName: column.label,
        flex: column.sizeFactor ?? 1,
        // @ts-ignore
        renderCell: column.renderCell,
        // type: column.type,
        // valueOptions: column.valueOptions,
        // align: column.align,
        // editable: column.editable,
        // headerAlign: column.headerAlign,
        // valueGetter: column.valueGetter,
        // valueSetter: column.valueSetter,
        // preProcessEditCellProps: column.preProcessEditCellProps,
        // renderEditCell: column.renderEditCell,
      }
    })
  }

  applySearch(searchString: string, tableData: any[]) {
    if (searchString.length === 0) {
      return tableData
    }

    const searchTerms = toLowerCaseCustom(searchString)
      .split(" ")
      .filter((term) => term)

    return tableData.filter((dataItem) => {
      const rowValues = Object.values(dataItem)
        .filter((value): value is string => typeof value === "string")
        .map((value) => toLowerCaseCustom(value))
        .join(" ")

      return searchTerms.every((term) => rowValues.includes(term))
    })
  }

  shouldCalculateFilterState = (currentFilterState: DataTableFilterState) => {
    return filterService.shouldCalculateFilterState(currentFilterState)
  }

  generateFilterState = (
    columnConfig: ColumnConfig[],
    tableData: Record<string, string>[],
    initialFilterState: DataTableFilterState,
  ) => {
    return filterService.generateFilterState(columnConfig, tableData, initialFilterState)
  }
}
